var getWidth = function (visibleSlides) {
    return visibleSlides < 1 ? "".concat((100 / visibleSlides).toFixed(0), "%") : 1 / visibleSlides;
};
var getVisibleSlides = function (visibleSlides) {
    return Array.isArray(visibleSlides)
        ? visibleSlides.map(function (vs) { return getWidth(vs); })
        : [getWidth(1.1), null, null, getWidth(2.1), getWidth(visibleSlides)];
};
var getCustomWidths = function (widths, index) { return [
    getWidth(1.1),
    null,
    null,
    getWidth(2.1),
    "".concat(widths[(index + widths.length) % widths.length], "%"),
]; };
export { getVisibleSlides, getCustomWidths };
//# sourceMappingURL=helpers.js.map